__turbopack_context__.v({
  "container": "mN7_dG_container",
  "description": "mN7_dG_description",
  "downloadButton": "mN7_dG_downloadButton",
  "grabber": "mN7_dG_grabber",
  "illustration": "mN7_dG_illustration",
  "modal": "mN7_dG_modal",
  "qrCode": "mN7_dG_qrCode",
  "sheet": "mN7_dG_sheet",
  "title": "mN7_dG_title",
});
